import { __async } from '../chunk-YSKSG3AS.mjs';
import { ConnectorNotFoundError, SwitchChainNotSupportedError } from 'wagmi';
import { InjectedConnector } from 'wagmi/connectors/injected';
import '@wagmi/core/window';
import { UserRejectedRequestError, ResourceUnavailableRpcError } from 'viem';

var mappingNetwork = {
  43111: "hemi-mainnet"
};
function getBybitWalletProvider() {
  return window.bybitWallet;
}
var BybitWalletConnector = class extends InjectedConnector {
  constructor({
    chains: _chains,
    options: _options
  } = {}) {
    var _a, _b;
    const options = {
      name: "BybitWallet",
      shimDisconnect: (_a = _options == null ? void 0 : _options.shimDisconnect) != null ? _a : false,
      shimChainChangedDisconnect: (_b = _options == null ? void 0 : _options.shimChainChangedDisconnect) != null ? _b : true
    };
    const chains = _chains == null ? void 0 : _chains.filter((c) => !!mappingNetwork[c.id]);
    super({
      chains,
      options
    });
    this.id = "BybitWallet";
  }
  connect() {
    return __async(this, arguments, function* ({ chainId } = {}) {
      var _a;
      try {
        const provider = yield this.getProvider();
        if (!provider) {
          throw new ConnectorNotFoundError();
        }
        if (provider.on) {
          provider.on("accountsChanged", this.onAccountsChanged);
          provider.on("chainChanged", this.onChainChanged);
          provider.on("disconnect", this.onDisconnect);
        }
        yield provider.enable();
        this.emit("message", { type: "connecting" });
        const account = yield this.getAccount();
        let id = yield this.getChainId();
        let unsupported = this.isChainUnsupported(id);
        if (chainId && id !== chainId) {
          const chain = yield this.switchChain(chainId);
          id = chain.id;
          unsupported = this.isChainUnsupported(id);
        }
        if (this.options.shimDisconnect)
          (_a = this.storage) == null ? void 0 : _a.setItem(this.shimDisconnectKey, true);
        return { account, chain: { id, unsupported }, provider };
      } catch (error) {
        if (this.isUserRejectedRequestError(error))
          throw new UserRejectedRequestError(error);
        if (error.code === -32002)
          throw new ResourceUnavailableRpcError(error);
        throw error;
      }
    });
  }
  switchChain(chainId) {
    return __async(this, null, function* () {
      const provider = yield this.getProvider();
      if (!provider)
        throw new ConnectorNotFoundError();
      if (mappingNetwork[chainId]) {
        try {
          yield provider.request({
            method: "wallet_switchEthereumChain",
            params: [{
              chainId
            }]
          });
          return this.chains.find((x) => x.id === chainId);
        } catch (error) {
          if (error.error === "user rejected") {
            throw new UserRejectedRequestError(error);
          }
        }
      }
      throw new SwitchChainNotSupportedError({ connector: this });
    });
  }
  getProvider() {
    return __async(this, null, function* () {
      return getBybitWalletProvider();
    });
  }
};

export { BybitWalletConnector, getBybitWalletProvider };
